import { toast } from 'material-react-toastify';
import errorMessages from './errorMessages';

const defaultToastConfig = {
  position: "top-right",
  autoClose: 2000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const showSuccessToast = (message) => {
  toast.success(message, defaultToastConfig);
};

export const showErrorToast = (error, customMessage = null) => {
  let errorMessage = customMessage || 'An error occurred';
  
  if (typeof error === 'string') {
    // If error is a string, use it directly
    errorMessage = error;
  } else if (error.response) {
    // Server responded with error
    const statusCode = error.response.status;
    const apiMessage = error.response.data?.message;
    
    if (customMessage) {
      // Use custom message if provided
      errorMessage = customMessage;
    } else if (apiMessage) {
      // Use API message if available
      errorMessage = apiMessage;
    } else if (errorMessages[statusCode]) {
      // Use predefined message for status code
      errorMessage = errorMessages[statusCode];
    }
  } else if (error.message) {
    // Client-side error with message
    errorMessage = customMessage || error.message;
  }

  toast.error(errorMessage, defaultToastConfig);
};

export const showInfoToast = (message) => {
  toast.info(message, defaultToastConfig);
};

export const showWarningToast = (message) => {
  toast.warning(message, defaultToastConfig);
};
